export const cdnImage = (source?: string) => {
  return {
    /** background image for the home page, etc.. */
    get bg() {
      return urlFor(source, { width: 3000, fit: 'max', q: 100 });
    },
    /** background image for the banners, etc.. */
    get bannerBg() {
      return urlFor(source, { width: 1600, fit: 'max' });
    },
    /** Leave the image as is, without any transformations */
    get asIs() {
      return urlFor(source, { asIs: true });
    },
    /** Add more getters here for other common image sizes */
  };
};
